<template>
  <li class="image-list__item" v-if="image">
    <div class="image-container">
      <img :src="image.MediumThumbnail">
      <div class="image-overlay">
        {{image.Description}}
        <p class="image-overlay__meta" v-if="image.HeightAndWidthText">H x W: {{image.HeightAndWidthText}}</p>
        <p class="image-overlay__meta">Extension: {{image.Extension}}</p>		
        <p class="image-overlay__meta">Resolution: {{image.ResolutionText}}</p>
      </div>
      <loading class="image-loader" v-if="imageProcessing && selected"></loading>
    </div>
    <div class="image__actions">
      <div class="checkbox">
        <input type="checkbox" :id="'image'+_uid" v-model="selected"><label @click="toggle" class="tick-green">Select: </label>
      </div>
      <select class="select image-list__select" v-model="resolution">
        <option :value="resolution.Value" v-for="resolution in resolutions">{{resolution.Text}}</option>
      </select>
    </div>
  </li>
</template>

<script>
  import Loading from "../../shared/Loading";
  import { selectImage, deselectImage } from "./ImagesActions";

  export default {
    props: ["image", "resolutions", "selectedResolution"],
    components: { Loading },
    vuex: {
      getters: {
        selectedImages: state => state.selectedImages,
        imageProcessing: state => state.imageProcessing
      },
      actions: { selectImage, deselectImage }
    },
    computed: {
      selected () {
        return this.selectedImages.indexOf(this.image) > -1;
      },
      resolution: {
        get () {
          var closest = this.resolutions.reduce(function (prev, curr) {
            return (Math.abs(curr.Value - this.selectedResolution) < Math.abs(prev.Value - this.selectedResolution) ? curr : prev);
          }.bind(this));

          return closest.Value;
        },
        set (value) {
          this.selectedResolution = value;
        }
      }
    },
    methods: {
      toggle: function () {
        if (this.selected) {
          this.deselectImage(this.image);
          this.selected = false;
        } else {
          this.image.SelectedResolution = this.resolution;
          this.selectImage(this.image);
          this.selected = true;
        }
      }
    },
    events: {
      "select-item": function () {
        this.selectImage(this.image);
        this.selected = true;
      }
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .image-list{
    &__item{
      @include col(30px);
      width: 25%;
      margin-bottom: 50px;
      color: $white;

      &:last-child{
        margin-right: 0;
      }
    }

    &__select{
      display: block;
      margin-bottom: 10px;
      width: 181px;
    }
  }

  .image-loader{
    position: absolute;
    top: 0;
    background: rgba($brown_light, .85);
    left: 0;
    right: 0;
    bottom: 0;

    >* {
      position: absolute;
      left: 50%;
      right: 50%;
      margin-right: -20px;
      margin-top: -20px;
    }
  }

  .image-container{
    height: 182px;
    border: 1px solid $green_dark;
    margin-bottom: 5px;
    position: relative;
    
    img{
      max-width: 100%;
      max-height: 100%;
    }

    &:hover .image-overlay{
      opacity: 1;
    }
  }

  .image-overlay{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($brown_light, 0.95);
    box-sizing: border-box;
    padding: 10px;
    color: $white;
    line-height: 21px;
    transition: opacity 0.25s;

    &__meta{
      color: $green_light;
      margin: 0;
    }
  }
</style>






// WEBPACK FOOTER //
// ImagesListItem.vue?211cab01